import { trackEvent } from '@/shared/analytics';
import { safeStorage } from '@/shared/utils/safeStorage';

interface AccountAddedParams {
  accountId: number;
  destinationCountry: string;
  schedulesFound?: number;
  source?: 'dashboard' | 'onboarding' | 'reconciled';
}

const dedupeKey = (accountId: number) => `visa_account_added_${accountId}`;

export function trackAccountAdded({
  accountId,
  destinationCountry,
  schedulesFound,
  source = 'reconciled',
}: AccountAddedParams): void {
  const key = dedupeKey(accountId);
  if (safeStorage.has(key)) return;

  trackEvent('visa_account_added', {
    destination_country: destinationCountry,
    schedules_found: schedulesFound,
    source,
  });

  safeStorage.remember(key);
}
